import { Grid, GridCellProps, GridColumn } from "@progress/kendo-react-grid";
import { Card, CardBody } from "@progress/kendo-react-layout";
import React, { useEffect, useState } from "react";
import styles from "../../../styles.module.css";
import style from "./style.module.css";
import { ICON_NAMES } from "utils/constant";
import { TextButton } from "ui/Button";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { PageTypePath } from "utils/pages";
import { getSettlementsApi } from "api/accounting";
import { Settlement } from "interface/accounting";
import { CustomRowRender } from "ui/grid/CustomGrid";
import {
	SettlementGridColumnItem,
	SettlementFrontGridColumnItem,
} from "component/pages/settlement/utilities/GridColumns";
import { lastColWithBtn } from "ui/grid/lastColumnts";
import { addMonths } from "date-fns";
import { PdfType } from "utils/PdfType";
import { useUserOrganizationsStore } from "store";
import { GrideDateFormatter } from "ui/Date";

function AccountingSettlementCard({
	isMobileView = false,
}: {
	isMobileView?: boolean;
}) {
	const [gridData, setGridData] = useState<Settlement[]>();
	const [statusOverrides, setStatusOverrides] = useState<Record<number, number>>({});

	const { t } = useTranslation();
	const navigate = useNavigate();
	const { defaultOrg } = useUserOrganizationsStore();

	useEffect(() => {
		getSettlementsApi({
			take: 3,
			skip: 0,
			fromDate: addMonths(new Date(), -12),
			toDate: new Date(),
			vesselLedgerAccountNumber: defaultOrg?.ledgerAccountNumber as any,
		})
			.then((response) => {
				setGridData(response.data);
			})
			.catch((err) => {
				console.log(err);
			});
	}, [defaultOrg?.ledgerAccountNumber]);

	const openPdfByRow = (prop: GridCellProps) => {
		window.open(`/${PageTypePath.Pdf}/${prop.dataItem.reportGuid}`, "_blank");

		if (prop.dataItem.status !== 1) {
			setStatusOverrides((prev) => ({ ...prev, [prop.dataItem.id]: 1 }));
		}
	};

	return (
		<div>
			<Card className={"home-card-item"}>
				<CardBody>
					<div className={`${styles.BoxHeadingMedium} ${style.CardBodyHeader}`}>
						<div>{t("LastSettlements")}</div>
						<div>
							<TextButton
								text={t("OverviewSettlements")}
								onClick={() => navigate(`/${PageTypePath.AccountingSettlement}`)}
								iconName={ICON_NAMES.Arrow}
							/>
						</div>
					</div>
					<div>
						{isMobileView ? (
							<div>
								{(gridData || []).map((item, index) => (
									<div
										key={`${item.invoiceNumber}-${index}`}
										className="home-mobile-list-item"
									>
										<div className="home-mobile-list-item-main">
											<div className="home-mobile-list-item-value">
												{item.invoiceNumber}
											</div>
											<div className="home-mobile-list-item-label">
												<GrideDateFormatter
													date={item.invoiceDate}
													formatType="dd.MM.yyyy"
													noTd={true}
												/>
											</div>
										</div>
										<div className="home-mobile-list-item-secondary">
											{item.grossValue || 0} kr
										</div>
										<div className="home-mobile-list-item-actions">
											<button
												type="button"
												className="home-mobile-icon-btn"
												onClick={() =>
													openPdfByRow({ dataItem: item } as GridCellProps)
												}
											>
												<img
													src={`/icon/${ICON_NAMES.Download}.svg`}
													alt={t("Download")}
												/>
											</button>
										</div>
									</div>
								))}
							</div>
						) : (
							<Grid
								style={{ height: "auto" }}
								rowHeight={38}
								rows={{ data: (row) => CustomRowRender(row) }}
								data={gridData}
								className={
									styles.tableColgroupColFirstChild + " custom_detail_grid"
								}
							>
								{SettlementFrontGridColumnItem(statusOverrides).map((column, key) => (
									<GridColumn key={key} {...column} className="no-border" />
								))}
								<GridColumn
									{...lastColWithBtn({
										width: "60px",
										showDetails: false,
										items: [
											{
												iconName: ICON_NAMES.Download,
												onclick: openPdfByRow,
												alwaysShow: true,
											},
										],
										showDelete: false,
									})}
								/>
							</Grid>
						)}
					</div>
				</CardBody>
			</Card>
		</div>
	);
}

export default AccountingSettlementCard;
